var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.65838 0.431419C4.74349 0.338405 4.86499 0.280273 5.00011 0.280273C5.11987 0.280273 5.23962 0.32678 5.33131 0.420246L7.67028 2.8046C7.8532 2.99107 7.8532 3.29291 7.67028 3.47939C7.48779 3.66541 7.19169 3.66541 7.00877 3.47939L5.46768 1.9084V6.48043C5.46768 6.74382 5.25843 6.95758 5.00005 6.95758C4.74168 6.95758 4.53199 6.74382 4.53199 6.48043V1.90932L2.9918 3.47939C2.80932 3.66541 2.51278 3.66541 2.33029 3.47939C2.14737 3.29291 2.14737 2.99107 2.33029 2.8046L4.65838 0.431419ZM0.789331 6.00467C1.04771 6.00467 1.25739 6.21842 1.25739 6.48182V8.38948C1.25739 8.51604 1.30653 8.63722 1.39427 8.72665C1.48201 8.81608 1.60087 8.86618 1.72502 8.86618H8.27477C8.39892 8.86618 8.51824 8.81609 8.60553 8.72665C8.69326 8.63722 8.74284 8.51604 8.74284 8.38948V6.48182C8.74284 6.21842 8.95209 6.00467 9.21046 6.00467C9.46928 6.00467 9.67853 6.21842 9.67853 6.48182V8.38948C9.67853 8.76913 9.5307 9.1327 9.26749 9.40144C9.00428 9.66976 8.64722 9.82046 8.27479 9.82046H1.72503C1.3526 9.82046 0.995962 9.66976 0.732765 9.40144C0.46912 9.13268 0.321289 8.76913 0.321289 8.38948V6.48182C0.321289 6.21842 0.530952 6.00467 0.789331 6.00467Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload_icon.85f8f8d8183da3c4ed207a37a06120e3.svg";
export { ForwardRef as ReactComponent };